import { Plot } from '../../core/plot';
import { deepAssign } from '../../utils';

/**
 * æ¡å½¢å¾é»è®¤éç½®é¡¹
 */
export const DEFAULT_OPTIONS = deepAssign({}, Plot.getDefaultOptions(), {
  barWidthRatio: 0.6,
  marginRatio: 1 / 32,
  tooltip: {
    shared: true,
    showMarkers: false,
    offset: 20,
  },
  legend: {
    radio: {},
  },
  interactions: [{ type: 'active-region' }],
});
